import classNames from "classnames/bind";
import { SplideSlide } from "react-splide-ts";

import style from './CarouselShop.module.scss';
const cx = classNames.bind(style);

export default function CarouselShopItem(props: ShopifyCarouselProduct) {

  const {
    title,
    featuredImage,
    priceRange: {
      minVariantPrice: {
        amount,
        currencyCode
      }
    },
    onlineStoreUrl
  } = props;

  const formattedAmount = parseFloat(amount).toFixed(2);

  // -------------------- Render

  return (
    <SplideSlide className={cx("carousel-shop-item")} aria-label={title}>
      <a className={cx("carousel-shop-item__link")}
        href={onlineStoreUrl}
        target="_blank"
      >
        <div className={cx("carousel-shop-item__image")}>
          <img src={featuredImage.url} alt={title} />
        </div>
        <div className={cx("carousel-shop-item__info")}>
          <p className={cx("title-lc-xs")}>{title}</p>
          <p className={cx("text-m", "carousel-shop-item__price")}>${`${formattedAmount} ${currencyCode}`}</p>
        </div>
      </a>
    </SplideSlide>
  );

}
